<header class="header" [class.header-z-top]="headerZIndexAlto" id="section-header" [class.header_fixed]="globalService.header.is_fixed">

  <div class="header_container" [ngClass]="{
      header_transparent: !url && globalService.header.above_carrousel && globalService.header.transparent_carrousel,
      header_absolute: !url && globalService.header.above_carrousel,
      complete: completeColor || url
    }" [style.top.px]="topPX" #header>

    <app-message #messageElement [hidden]="!globalService.header.base_visible_message"
      [href]="globalService.header.message_link" [text]="globalService.header.message_text"
      [type]="globalService.header.type_message_id" [extra]="globalService.header.message_time"
      [class.top]="globalService.header.message_position_top" [ngClass]="{
          'complete': completeColor || url || !globalService.header.above_carrousel
        }">
    </app-message>

    <app-message #secondMessageElement [hidden]="!globalService.header.second_base_visible_message"
      [href]="globalService.header.second_message_link" [text]="globalService.header.second_message_text"
      [type]="globalService.header.second_type_message_id"
      [class.top]="globalService.header.second_message_position_top" [ngClass]="{
          'complete': completeColor || url || !globalService.header.above_carrousel
        }" [useSecondaryColor]="true">
    </app-message>

    <div class="content container">

      <div class="actions">
        <div class="actions_element hidden-portrait">
          <app-searchbar>
          </app-searchbar>
        </div>
      </div>

      <app-logo class="logo">
      </app-logo>

      <div class="actions end">

        <div class="actions_element hidden-portrait">
          <app-user-menu>
          </app-user-menu>
        </div>

        <div class="actions_element hidden-desktop">
          <app-searchbar>
          </app-searchbar>
        </div>

        <div class="actions_element">
          <app-shopping-cart #shoppingCart>
          </app-shopping-cart>
        </div>

      </div>

      <app-button-menu [menu]="menu">
      </app-button-menu>

    </div>

    <div class="content-second-line container">
      <app-navbar [menu]="menu">
      </app-navbar>
    </div>

  </div>

</header>
<ng-template #ViewContainer>
</ng-template>

